import { DefaultLinkAsset } from "./defaultLinkAsset";
import { DisplayTypes } from "lib/types/asset";
import { AssetIframe, AssetImageLink, AssetVideoLink } from "../../enhanced";
import { EmbeddedLinkAsset } from "./embeddedLinkAsset";
import { getTypeofAsset } from "../../utils";

export const DisplayLinkAsset = ({ asset }) => {
  if (!asset.data?.embedded) {
    return <DefaultLinkAsset asset={asset} title={asset?.data.title} url={asset?.data.url}  />
  }

  switch (getTypeofAsset(asset)) {
    case DisplayTypes.VIDEO:
      return <AssetVideoLink asset={asset} />;
    case DisplayTypes.IMAGE:
      return <AssetImageLink asset={asset} />;
    case DisplayTypes.OEMBED:
      return <AssetIframe data={asset.data.oembed} />;
    default:
      return <EmbeddedLinkAsset asset={asset} />;
  }
}
